import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { firstValueFrom, forkJoin, from, Observable, of } from 'rxjs';
import { DeviceCountPerimeterResponse } from '../models/device.model';
import { ConfigurationManagerService } from './configuration-manager.service';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import moment from 'moment';
import _ from 'lodash';
import { DeviceMapEntity } from './device-map-entity';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { DataContextService } from './data-context.service';
import { ArcAngelUser } from './arc-angel-user.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimelineService } from './timeline.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  data: any = {
    userStatusByIncident: [],
    userStatusByIncidentDict: [],
    procallDevices: [], // Add this property
    // ... other existing properties
  };
  playbackDevices: any = {};
  monitorLiveDevices: any = {};
  constructor(
    private api: ApiService,
    private cameraService: CameraService,
    private coreService: CoreService,
    private dataContext: DataContextService,
    private windowService: WindowService,
    private modalService: NgbModal,
    private timelineService: TimelineService
  ) {}
  getCountDevicesByPerimeterAndStatus(
    incidentId: number
  ): Observable<DeviceCountPerimeterResponse> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/countDevicesByPerimeterAndStatus`;
    const body = {};
    return this.api.post<DeviceCountPerimeterResponse>(url, body).pipe(
      tap((results: any) => {
        if (results) {
          this.data.userStatusByIncident[incidentId] = results;
          const dict: any = {};
          _.forEach(results, (d: any) => {
            dict[d.id] = d;
          });
          this.data.userStatusByIncidentDict[incidentId] = dict;
          return dict;
        }
        return null;
      })
    );
  }

  getCountCampusDevicesByPerimeterAndStatus(
    incidentId: number
  ): Observable<DeviceCountPerimeterResponse> {

    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/countCampusDevicesByPerimeterAndStatus`;

    const body = {};

    return this.api.post<DeviceCountPerimeterResponse>(url, body).pipe(
      tap((results: any) => {
        if (results) {

          // Store raw response (same as first method)
          this.data.userStatusByIncident[incidentId] = results;

          // Create dictionary
          const dict: any = {};
          _.forEach(results, (d: any) => {
            dict[d.id] = d;
          });

          // Store dictionary
          this.data.userStatusByIncidentDict[incidentId] = dict;

          return dict;
        }
        return null;
      })
    );
  }

  // getCountCampusDevicesByPerimeterAndStatus(
  //   campusPerimeterId: number
  // ): Observable<DeviceCountPerimeterResponse> {

  //   const url =
  //     ConfigurationManagerService.settings.BaseURL +
  //     ConfigurationManagerService.settings.countCampusDevicesByPerimeterAndStatus;

  //   const param = {
  //     campusPerimeterId: campusPerimeterId
  //   };

  //   return this.api.post<DeviceCountPerimeterResponse>(url, param).pipe(
  //     tap((results: any) => {
  //       if (results) {

  //         // Store raw response
  //         this.data.userStatusByIncidentDict[campusPerimeterId] = results;

  //         // Create dictionary
  //         const dict: any = {};
  //         _.forEach(results, (d: any) => {
  //           dict[d.id] = d;
  //         });

  //         // Store dictionary
  //         this.data.userStatusByIncidentDict[campusPerimeterId] = dict;

  //         return dict;
  //       }
  //       return null;
  //     })
  //   );
  // }

  findOrClusterUsersByBbox(
    incidentId: number | string,
    gridSize: number,
    threshold: number,
    bbox: [number, number],
    floorType: string,
    floorPerimeterId: number | string,
    statuses: string[]
  ): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/findOrClusterUsersByBbox`;
    const body = {
      gridSize,
      threshold,
      bbox,
      floorType,
      floorPerimeterId,
      statuses,
    };
    return this.api.post<any>(url, body);
  }

  // Add method to get procall devices
  getProcallDevices(): any {
    return this.data.procallDevices;
  }

  // Add method to set procall devices
  setProcallDevices(devices: any): void {
    this.data.procallDevices = devices;
  }
  getFloorUserInBBoxPlayback(
    incidentId: string,
    timestamp: number,
    gridSize: number,
    threshold: number,
    bbox: number[],
    floorPerimeterId: string | null,
    floorType: string,
    statuses: string[]
  ): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/findOrClusterUsersByBboxHistory`;
    const time = moment(timestamp).toISOString();
    const body = {
      timestamp: time,
      gridSize: gridSize,
      threshold: threshold,
      bbox: bbox,
      floorPerimeterId: floorPerimeterId,
      floorType: floorType,
      statuses: statuses,
    };

    return this.api.post<any>(url, body);
  }

  getUserOnStreetPlayback(
    incidentId: string,
    timestamp: number,
    statuses: string[],
    limit: number,
    page: number
  ): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/usersOnStreetHistory`;
    const time = moment(timestamp).toISOString();
    const body = {
      timestamp: time,
      statuses: statuses,
      limit: limit,
      page: page,
    };

    return this.api.post<any>(url, body);
  }

  getUserInGeofencePlayback(
    incidentId: string,
    timestamp: number,
    statuses: string[],
    limit: number,
    page: number
  ): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/usersInGeofenceHistory`;
    const time = moment(timestamp).toISOString();
    const body = {
      timestamp: time,
      statuses: statuses,
      limit: limit,
      page: page,
    };

    return this.api.post<any>(url, body);
  }

  getDeviceForPlaybackProcall(procalldata: any): Observable<any> {
    const createdAt = new Date(procalldata.createdAt).toISOString();
    const updated = procalldata.endedAt ? new Date(procalldata.endedAt) : null;
    const endedAt = updated
      ? new Date(updated.setSeconds(updated.getSeconds() + 1)).toISOString()
      : 'Infinity';
    const key = procalldata.id + '-' + createdAt + '-' + endedAt;

    const paramIncident = {
      attributes: ['incidentId', 'status', 'createdAt', 'validAt'],
      where: {
        incidentId: procalldata.id,
        validAt: {
          $overlap: [createdAt, endedAt],
        },
      },
      order: [['validAt', 'ASC']],
      limit: 10000,
    };
    const paramDevice = {
      attributes: ['deviceId', 'status', 'validAt'],
      order: [['validAt', 'ASC']],
      limit: 10000,
    };

    let results: any = {};

    return forkJoin({
      incidents: this.api.post<any>(
        ConfigurationManagerService.settings.BaseURL +
          'db/IncidentHistory/findAndCountAll',
        paramIncident
      ),
      devices: this.api.post<any>(
        ConfigurationManagerService.settings.BaseURL +
          `db/Incident/${procalldata.id}/findAndCountAllIncidentDeviceHistories`,
        paramDevice
      ),
    }).pipe(
      switchMap((result) => {
        results.incidents = result.incidents.rows;
        results.devices = result.devices.rows;
        if (!results.incidents.length || !results.devices.length) {
          return of({ count: 0, rows: [] });
        }
        const paramLocation = {
          attributes: [
            'closestBeaconId',
            'accuracy',
            'speed',
            'direction',
            'position',
            'updatedAt',
          ],
          where: {
            $and: [
              { updatedAt: { $gte: createdAt } },
              { updatedAt: { $lte: endedAt } },
            ],
          },
          limit: 10000,
          order: [['updatedAt', 'ASC']],
        };

        return this.api
          .post<any>(
            ConfigurationManagerService.settings.BaseURL +
              `db/Incident/${procalldata.id}/findAndCountAllLocationHistories`,
            paramLocation
          )
          .pipe(
            map((locationResult) => {
              results.locations = locationResult.rows;
              if (!results.locations.length) {
                return null;
              }

              const deviceId = results.devices[0].deviceId;

              let combos = toCompoundHistoryCollection({
                incident: results.incidents,
                incidentDevice: results.devices,
                location: results.locations,
              });

              let statuses = _.map(combos, (value: any) => ({
                status: value.incidentDevice.status,
                position: value.location.position,
                installationId: deviceId,
                speed: value.location.speed * 3.6,
                direction: value.location.direction,
                accuracy: value.location.accuracy,
                fixTime: value.location.updatedAt,
                profileId: procalldata.profileId,
                beacons: value.location.closestBeaconId
                  ? [value.location.closestBeaconId]
                  : [],
                closestBeacon: value.location.closestBeaconId,
                createdAt: new Date(value.timestamp).toISOString(),
                updatedAt: new Date(value.timestamp).toISOString(),
                altitude: 0,
              }));

              let device: any | null = null;
              _.forEach(statuses, (value: any) => {
                if (!device) {
                  device = new DeviceMapEntity(
                    value.installationId,
                    value.status,
                    value.position.coordinates,
                    value.altitude,
                    value.createdAt,
                    '',
                    true,
                    true,
                    value.speed,
                    value.direction,
                    this.cameraService,
                    this.coreService,
                    this.windowService,
                    this.dataContext,
                    this.modalService,
                    this.timelineService
                  );
                  device.setProfileId(value.profileId);
                  this.setDeviceUserDtoWithProfile(device, value.profileId);
                  device.setInsideAnIncident(false);
                  device.setProcallState(true);
                  device.setProcallId(procalldata.id);
                  this.dataContext.addMapEntity(device);
                }
              });

              return device;
            })
          );
      }),
      catchError((error) => {
        console.error('Error getting procall device.', error);
        return of(null);
      })
    );
  }
  getIncidentDeviceDataByDeviceId(
    user: any,
    incident: any,
    time?: string
  ): Observable<any> {
    const deviceId = user.deviceId;
    let incidentId: string | number | undefined;
    if (
      incident &&
      typeof incident.getEventId === 'function' &&
      incident.getEventId()
    ) {
      incidentId = incident.getEventId();
    } else if (incident?.building?.incidents?.[0]?.eventId) {
      incidentId = incident.building.incidents[0].eventId;
    }

    if (!deviceId || !incidentId) {
      return of(null);
    }

    let calls: { [key: string]: Observable<any> };

    if (!time) {
      // Live mode
      const paramDevice = {
        attributes: ['userId'],
        where: { id: deviceId },
      };
      const paramIncidentDevice = {
        where: { deviceId, incidentId },
      };
      const paramLocation = {
        where: { deviceId },
      };

      calls = {
        device: this.api.post<any>(
          `${ConfigurationManagerService.settings.BaseURL}db/Device/findAndCountAllFromOrganization`,
          paramDevice
        ),
        incidentDevice: this.api.post<any>(
          `${ConfigurationManagerService.settings.BaseURL}db/IncidentDevice/findAndCountAllFromOrganization`,
          paramIncidentDevice
        ),
        location: this.api.post<any>(
          `${ConfigurationManagerService.settings.BaseURL}db/Location/findAndCountAllFromOrganization`,
          paramLocation
        ),
      };
    } else {
      // Playback mode
      const time1 = moment(time).add(0.001, 'seconds').toISOString();
      const paramDevice = {
        attributes: ['userId'],
        where: { deviceId, validAt: { $overlap: [time, time1] } },
        limit: 1,
      };
      const paramIncidentDevice = {
        where: { deviceId, incidentId, validAt: { $overlap: [time, time1] } },
        limit: 1,
      };
      const paramLocation = {
        where: { deviceId, validAt: { $overlap: [time, time1] } },
      };

      calls = {
        device: this.api.post<any>(
          `${ConfigurationManagerService.settings.BaseURL}db/Device/findAndCountAllFromOrganization`,
          paramDevice
        ),
        incidentDevice: this.api.post<any>(
          `${ConfigurationManagerService.settings.BaseURL}db/IncidentDevice/findAndCountAllFromOrganization`,
          paramIncidentDevice
        ),
        location: this.api.post<any>(
          `${ConfigurationManagerService.settings.BaseURL}db/Location/findAndCountAllFromOrganization`,
          paramLocation
        ),
      };
    }

    return forkJoin(calls).pipe(
      switchMap((results) => {
        const deviceData = results['device']?.rows?.[0];
        const incidentDeviceData = results['incidentDevice']?.rows?.[0];
        const locationData = results['location']?.rows?.[0];

        if (deviceData && incidentDeviceData && locationData) {
          let altitude = 0;
          // You may need to inject or pass 'myPerimeters' data here
          // if (locationData.closestPerimeterId && this.data.myPerimeters[locationData.closestPerimeterId]?.height) {
          //   altitude = this.data.myPerimeters[locationData.closestPerimeterId].height;
          // }

          let status = incidentDeviceData.status.toLowerCase();
          if (status === 'danger') status = 'unsafe';

          const device = {
            id: deviceId,
            profileId: deviceData.userId,
            userId: deviceData.userId,
            closestBeacon: locationData.closestBeaconId,
            status,
            position: locationData.position,
            altitude,
            speed: locationData.speed || 0.0,
            heading: locationData.heading || 0.0,
            updatedAt: moment(locationData.updatedAt).toISOString(),
            isPlayback: !!time,
          };
          return this.createOrUpdateDevicemapEntity(device, incident);
        }
        return of(null);
      }),
      catchError((error) => {
        console.error('Error in getIncidentDeviceDataByDeviceId', error);
        return of(null);
      })
    );
  }
  createOrUpdateDevicemapEntity(device: any, mapEntity: any): Observable<any> {
    // Handle affectedBeacons
    if (
      mapEntity.affectedBeacons &&
      device.closestBeacon &&
      mapEntity.affectedBeacons[device.closestBeacon] &&
      mapEntity.affectedBeacons[device.closestBeacon].geometry
    ) {
      device.position.coordinates =
        mapEntity.affectedBeacons[device.closestBeacon].geometry.coordinates;
    }

    // Default altitude
    if (!device.altitude) {
      device.altitude = 0;
    }

    // Handle affectedPerimeters
    if (mapEntity.affectedPerimeters) {
      for (const perimeter of mapEntity.affectedPerimeters) {
        if (
          device.closestBeacon &&
          perimeter.beacons[device.closestBeacon] &&
          perimeter.height
        ) {
          device.altitude = perimeter.height;
          break; // Use break, not return false
        }
      }
    }

    // Cluster device to closest beacon (if beaconLocations available)
    // You may need to inject or pass beaconLocations if needed
    // if (device.closestBeacon && beaconLocations[device.closestBeacon]) {
    //   device.position.coordinates = [
    //     beaconLocations[device.closestBeacon].lon,
    //     beaconLocations[device.closestBeacon].lat,
    //   ];
    //   device.altitude = beaconLocations[device.closestBeacon].alt;
    // }

    let exists = false;
    if (device.isPlayback && device.id in this.playbackDevices) exists = true;
    if (!device.isPlayback && device.id in this.monitorLiveDevices)
      exists = true;

    let deviceEntity;

    if (!exists) {
      deviceEntity = new DeviceMapEntity(
        device.id,
        device.status,
        device.position.coordinates,
        device.altitude,
        device.updatedAt,
        this.getSafeEventId(mapEntity),
        true,
        true,
        device.speed,
        device.heading,
        this.cameraService,
        this.coreService,
        this.windowService,
        this.dataContext,
        this.modalService,
        this.timelineService
      );
      deviceEntity.isPlayback = device.isPlayback;
      if (!device.isPlayback) {
        deviceEntity.setInsideAnIncident(true);
      }
      deviceEntity.setProfileId(device.profileId);
      this.dataContext.addMapEntity(deviceEntity, 'incident-devices');
      if (device.isPlayback) this.playbackDevices[device.id] = deviceEntity;
      else this.monitorLiveDevices[device.id] = deviceEntity;
    } else {
      deviceEntity = device.isPlayback
        ? this.playbackDevices[device.id]
        : this.monitorLiveDevices[device.id];
      deviceEntity.update(device);
      deviceEntity.setEventId(mapEntity.getEventId());
      if (!device.isPlayback) {
        deviceEntity.setInsideAnIncident(true);
      }
    }

    deviceEntity.updateClosestBeacon(device.closestBeacon);
    if (mapEntity && typeof mapEntity.addDevice === 'function') {
      mapEntity.addDevice(deviceEntity);
    } else {
      mapEntity?.building?.incidents?.[0]?.addDevice(deviceEntity);
    }
    deviceEntity.cesiumEntity.show = true;

    if (!deviceEntity.getUserDto()) {
      // set profile
      return from(
        this.getUserProfile(device.userId).then((dto: any) => {
          deviceEntity.setUserDto(dto);
          return deviceEntity;
        })
      );
    }

    return of(deviceEntity);
  }
  getSafeEventId(mapEntity: any) {
    if (
      mapEntity &&
      typeof mapEntity.getEventId === 'function' &&
      mapEntity.getEventId()
    ) {
      return mapEntity.getEventId();
    } else if (mapEntity?.building?.incidents?.[0]?.eventId) {
      return mapEntity.building.incidents[0].eventId;
    }
    return undefined;
  }

  private profiles: Record<string, any> = {};

  setDeviceUserDtoWithProfile(device: any, profileId: string): void {
    this.getUserProfile(profileId)
      .then((dto) => {
        device.setUserDto(dto);
      })
      .catch((error) => {
        console.error(
          'Error getting user profile while setting user dto.',
          error
        );
      });
  }

  getUserProfile(profileId: string, force = false): Promise<any> {
    if (force) {
      delete this.profiles[profileId];
    }
    return this.getUserProfiles([profileId]).then((result) => result[0]);
  }

  getUserProfiles(ids: string[]): Promise<any[]> {
    const checked: Record<string, boolean> = {};
    const excluded: string[] = [];
    const results: any[] = [];

    (ids || []).forEach((id) => {
      if (!(id in checked)) {
        checked[id] = true;
        if (id in this.profiles) {
          results.push(this.profiles[id]);
        } else {
          excluded.push(id);
        }
      }
    });

    return this.generateProfiles(Array.isArray(ids) ? excluded : null).then(
      (profiles) => {
        return _.sortBy(results.concat(profiles), 'id');
      }
    );
  }

  private generateProfiles(profileIds: string[] | null): Promise<any[]> {
    return this.getUserProfilesFromApi(profileIds)
      .then((results) => {
        return results.map((profile) => {
          const arcuser = new ArcAngelUser(profile);
          const id = arcuser.getId();
          if (id !== undefined) {
            this.profiles[id] = arcuser;
          }
          return arcuser;
        });
      })
      .catch((error) => {
        console.error('generateProfiles error', error);
        return [];
      });
  }

  private getUserProfilesFromApi(ids: string[] | null): Promise<any[]> {
    const param: any = {
      where: {
        id: ids,
      },
      limit: 10000,
    };

    if (!Array.isArray(ids)) {
      delete param.body.where;
    } else if (!ids.length) {
      return Promise.resolve([]);
    }

    return firstValueFrom(
      this.api
        .post<any>(
          ConfigurationManagerService.settings.BaseURL +
            'db/User/profilesFromOrganization',
          param
        )
        .pipe(
          map((result) =>
            result.rows.map((row: any) => transforms.userProfile(row))
          ),
          catchError((error) => {
            console.error('getUserProfilesFromApi error', error);
            return of([]);
          })
        )
    );
  }

  getUserOnStreet(
    incidentId: string,
    statuses: string[],
    limit: number,
    page: number
  ): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/usersOnStreet`;
    const body = {
      statuses: statuses,
      limit: limit,
      page: page,
    };
    return this.api.post<any>(url, body);
  }

  getUserInGeofence(
    incidentId: string,
    statuses: string[],
    limit: number,
    page: number
  ): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL}db/Incident/${incidentId}/usersInGeofence`;
    const body = {
      statuses: statuses,
      limit: limit,
      page: page,
    };
    return this.api.post<any>(url, body);
  }
}

function toCompoundHistoryCollection(collections: any): any[] {
  const devices = collections.incidentDevice || [];
  const locations = collections.location || [];
  return locations.map((loc: any, idx: number) => ({
    incidentDevice: devices[idx] || {},
    location: loc,
    timestamp: loc.updatedAt,
  }));
}

export const transforms = {
  device: function (value: any): any {
    let result: any = null;
    if (value) {
      result = {
        attributes: {
          deviceModel: value.type,
          deviceName: value.name,
          systemName: value.systemName,
          systemVersion: value.systemVersion,
        },
        build: {
          packageName: '',
          buildAt: value.applicationBuild,
          version: value.applicationVersion,
        },
        gps: true,
        nfc: true,
        id: value.id,
        pushToken: value.token,
        system: value.systemName,
      };
    }
    return result;
  },

  name: function (
    value: string
  ): { firstName?: string; LastName?: string; name: string } | null {
    let result: { firstName?: string; LastName?: string; name: string } | null =
      null;
    if (value) {
      value.replace(/^((\S*)\s+)?(\S+.*)$/, (match, firstpart, first, last) => {
        result = {
          firstName: first,
          LastName: last,
          name: match,
        };
        return '';
      });
    }
    return result;
  },

  userProfile: function (data: any): any {
    const transformed: any = {
      attributes: {
        activeTracking: true,
        bluetoothTrigger: true,
        calendarProtection: true,
        company: null,
        country: null,
        dateOfBirth: null,
        demoUser: false,
        dob: null,
        employeeId: null,
        isDevice: false,
        medical: '...',
        photo: null,
        remote: false,
        title: null,
        travelling: false,
        view: null,
        homeAddress: null,
        preferences: null,
        reportsTo: null,
        splitAddress: null,
        travellingTo: null,
        userLastKnownLocation: null,
        userProfileLocation: null,
        workAddress: null,
        workFacility: null,
        departments: [],
        groups: [],
        units: [],
        address:
          !data.UserAddresses || !data.UserAddresses.length
            ? null
            : data.UserAddresses[0].address,
        email:
          !data.UserEmails ||
          !data.UserEmails.length ||
          !data.UserEmails[0].address
            ? ''
            : data.UserEmails[0].address,
        emergencyContacts: null,
        updatedAt: data.updatedAt,
      },
      manuallyCreated: true,
      newMessages: 0,
      status: 'unknown',
      view: '',
      welcomeEmailSent: null,
      auths: {},
      invitations: {},
      meta: null,
      preferences: {},
      subscription: {},
      supportNumber: null,
      permissions: [],
      createdAt: data.createdAt,
      id: data.id,
      installations: _.map(data.Devices || [], transforms.device),
      organizations: _.map(
        data.UserOrganizations || [],
        (org: any) => org.Organization.id
      ),
      updatedAt: data.updatedAt,
    };

    _.assign(transformed.attributes, transforms.name(data.name));

    transformed.attributes.emergencyContacts = _.map(
      data.EmergencyContacts || [],
      (contact: any, index: number) => {
        transformed.attributes['emergencyContact' + index] =
          transforms.emergencyContact(contact);
        return transforms.phoneNumber(contact.phoneNumber);
      }
    );

    _.forEach(data.UserPhones || [], (phone: any) => {
      switch ((phone.type || '').toLowerCase()) {
        case 'landline':
          transformed.attributes.landlinePhone = transforms.phoneNumber(
            phone.number
          );
          break;
        case 'mobile':
          transformed.attributes.mobilePhone = transforms.phoneNumber(
            phone.number
          );
          break;
        case 'work':
          transformed.attributes.workPhone = transforms.phoneNumber(
            phone.number
          );
          break;
      }
    });
    transformed.attributes.phone =
      transformed.attributes.mobilePhone ||
      transformed.attributes.landlinePhone ||
      transformed.attributes.workPhone;
    transformed.attributes.primaryEmergency =
      transformed.attributes.emergencyContacts[0];
    transformed.attributes.secondaryEmergency =
      transformed.attributes.emergencyContacts[1];

    if (data.isSuper) {
      transformed.permissions.push('SUPERUSER');
    }

    return transformed;
  },

  phoneNumber: function (
    value: string
  ): { countryCode: string; number: string } | null {
    let result: { countryCode: string; number: string } | null = null;
    if (value) {
      value.replace(/^\D*(\d*)(\d{10,}(.*))$/, (match, country, number) => {
        result = {
          countryCode: country,
          number: number,
        };
        return '';
      });
    }
    return result;
  },

  emergencyContact: function (
    value: any
  ): { email: string; name: string; relation: string } | null {
    if (value) {
      return {
        email: value.email,
        name: value.name,
        relation: value.relation,
      };
    }
    return null;
  },
};
